"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.map");

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/es7.object.entries");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.sort");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.object.values");

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _send = require("@/api/cms/send");

var _dictDetail = require("@/api/system/dictDetail");

var _index = require("@/utils/index");

var _deliveryColumns = _interopRequireDefault(require("./deliveryColumns"));

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'DeliveryManagement',
  components: {
    draggable: _vuedraggable.default
  },
  dicts: ['delivery_list_display_fieIds'],
  created: function created() {
    var _this = this;

    this.$on('dictReady', function () {
      _this.initTableHeader();
    });
  },
  data: function data() {
    return {
      searchLoading: false,
      exportLoading: false,
      searchForm: {
        orderDate: [],
        dispatchDate: [],
        deliveryDate: [],
        dealer: '',
        applyDate: [],
        sendDate: [],
        signDate: [],
        saleNo: '',
        customerName: '',
        customerPhone: '',
        customerAddress: '',
        contractNo: ''
      },
      statistics: {
        total: 0,
        pendingSubmit: 0,
        pendingCommit: 0,
        pendingAppointment: 0,
        pendingDelivery: 0,
        pendingArrival: 0,
        pendingReceipt: 0,
        delivered: 0,
        completed: 0,
        pendingAudit: 0,
        pendingPrint: 0,
        pendingStock: 0,
        pendingSend: 0,
        shipped: 0
      },
      productionStatusMap: {
        10: '未提交',
        20: '待审图',
        30: '退回',
        40: '待确认图纸',
        45: '待工厂受理',
        50: '待拆单审核',
        51: '待移门拆单',
        55: '待拆单复审',
        60: '待报价审核',
        70: '待报价复审',
        80: '待经销商确认',
        90: '待付款确认',
        100: '待财务审核',
        105: '待物料采购',
        107: '待外协受理',
        110: '待生产计划',
        120: '计划已接单',
        130: '已排生产计划',
        150: '开始生产',
        160: '部分入库',
        170: '全部入库',
        180: '部分发货',
        190: '全部发货',
        200: '取消'
      },
      activeStatus: 0,
      activeOtherStatus: 0,
      activeSendWay: '',
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      selectedRows: [],
      nestedSelectedRowIds: {},
      screenWidth: document.documentElement.clientWidth || document.body.clientWidth,
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      tableHeader: [],
      pendingSubmitHeader: [],
      otherHeader: [],
      configDialogVisible: false,
      originalHeaderConfig: [],
      tableRenderKey: 0,
      draftDialogVisible: false,
      draftItems: [],
      draftSelectedId: null,
      draftSourceData: null,
      attachmentDialogVisible: false,
      attachmentPreviewList: []
    };
  },
  computed: {
    hasAnySelection: function hasAnySelection() {
      if (this.selectedRows.length > 0) return true;
      return Object.values(this.nestedSelectedRowIds).some(function (v) {
        return v;
      });
    },
    tableHeight: function tableHeight() {
      return this.screenHeight * 0.55;
    },
    statusTabs: function statusTabs() {
      if (this.activeSendWay && this.activeSendWay !== '配送(到家)' && this.activeSendWay !== '配送(到物流点)') {
        return [{
          label: '全部',
          value: null,
          count: this.statistics.total
        }, {
          label: '待发起',
          value: 0,
          count: this.statistics.pendingSubmit
        }, {
          label: '待审核',
          value: 1010,
          count: this.statistics.pendingAudit
        }, {
          label: '待打单',
          value: 1020,
          count: this.statistics.pendingPrint
        }, {
          label: '待备货',
          value: 1030,
          count: this.statistics.pendingStock
        }, {
          label: '待发货',
          value: 1040,
          count: this.statistics.pendingSend
        }, {
          label: '已发货',
          value: 1050,
          count: this.statistics.shipped
        }];
      }

      return [{
        label: '全部',
        value: null,
        count: this.statistics.total
      }, {
        label: '待发起',
        value: 0,
        count: this.statistics.pendingSubmit
      }, {
        label: '待提交',
        value: 1,
        count: this.statistics.pendingCommit
      }, {
        label: '待预约',
        value: 10,
        count: this.statistics.pendingAppointment
      }, {
        label: '待出发',
        value: 20,
        count: this.statistics.pendingDelivery
      }, {
        label: '待到达',
        value: 30,
        count: this.statistics.pendingArrival
      }, {
        label: '待送达',
        value: 40,
        count: this.statistics.pendingReceipt
      }, {
        label: '待核算',
        value: 50,
        count: this.statistics.delivered
      }, {
        label: '已核算',
        value: 60,
        count: this.statistics.completed
      }];
    },
    sendWayTabs: function sendWayTabs() {
      return [{
        label: '全部',
        value: ''
      }, {
        label: '配送(到家)',
        value: '配送(到家)'
      }, {
        label: '配送(到物流点)',
        value: '配送(到物流点)'
      }, {
        label: '自提',
        value: '自提'
      }, {
        label: '物流',
        value: '物流'
      }, {
        label: '快递',
        value: '快递'
      }, {
        label: '闪送',
        value: '闪送'
      }];
    },
    otherStatusTabs: function otherStatusTabs() {
      return [{
        label: '全部',
        value: null,
        count: this.statistics.total
      }, {
        label: '待发起',
        value: 0,
        count: this.statistics.pendingSubmit
      }, {
        label: '待审核',
        value: 1010,
        count: this.statistics.pendingAudit
      }, {
        label: '待打单',
        value: 1020,
        count: this.statistics.pendingPrint
      }, {
        label: '待备货',
        value: 1030,
        count: this.statistics.pendingStock
      }, {
        label: '待发货',
        value: 1040,
        count: this.statistics.pendingSend
      }, {
        label: '已发货',
        value: 1050,
        count: this.statistics.shipped
      }];
    },
    visibleColumns: {
      get: function get() {
        return this.tableHeader.filter(function (col) {
          return col.visible;
        });
      },
      set: function set(val) {
        var _this2 = this,
            _this$tableHeader;

        var visibleKeys = new Set(val.map(function (c) {
          return c.key;
        }));
        this.tableHeader.forEach(function (col) {
          col.visible = visibleKeys.has(col.key);
        }); // 按拖拽后的顺序重新排列

        var ordered = [];
        val.forEach(function (col) {
          var found = _this2.tableHeader.find(function (c) {
            return c.key === col.key;
          });

          if (found) ordered.push(found);
        });
        this.tableHeader.forEach(function (col) {
          if (!visibleKeys.has(col.key)) ordered.push(col);
        }); // 原地替换数组内容

        (_this$tableHeader = this.tableHeader).splice.apply(_this$tableHeader, [0, this.tableHeader.length].concat(ordered));

        this.tableRenderKey++;
      }
    }
  },
  watch: {
    activeStatus: function activeStatus() {
      this.syncTableHeader();
    },
    tableHeader: {
      handler: function handler() {
        this.tableRenderKey++;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);

    if (sessionStorage.getItem('delivery_keepState') === 'true') {
      sessionStorage.removeItem('delivery_keepState');
      this.loadData();
      this.loadStatistics();
      this._justMounted = true;
      return;
    }

    this.applyRouteStatus();

    if (sessionStorage.getItem('delivery_refresh') === 'true') {
      sessionStorage.removeItem('delivery_refresh');
      this.loadData();
      this.loadStatistics();
    } else {
      this.loadData();
      this.loadStatistics();
    }

    this._justMounted = true;
  },
  activated: function activated() {
    if (this._justMounted) {
      this._justMounted = false;
      return;
    }

    if (sessionStorage.getItem('delivery_keepState') === 'true') {
      sessionStorage.removeItem('delivery_keepState');
      this.loadData();
      this.loadStatistics();
      return;
    }

    this.applyRouteStatus();
    this.loadData();
    this.loadStatistics();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    applyRouteStatus: function applyRouteStatus() {
      var statusMap = {
        '待发起': 0,
        '待派单': 0,
        '待预约': 10,
        '待出发': 20,
        '待到达': 30,
        '待送达': 40,
        '待核算': 50,
        '已核算': 60,
        '待审核': 1010,
        '待打单': 1020,
        '待备货': 1030,
        '待发货': 1040,
        '已发货': 1050,
        '审核驳回': 1011
      };
      var otherStatusValues = [1010, 1020, 1030, 1040, 1050, 1011];
      var status = this.$route.query.status;

      if (status && status !== '') {
        var numericStatus = statusMap[status];

        if (numericStatus !== undefined) {
          if (otherStatusValues.includes(numericStatus)) {
            this.activeOtherStatus = numericStatus;
          }

          this.activeStatus = numericStatus;
          return;
        }
      }

      this.activeStatus = 0;
      this.activeOtherStatus = 0;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0];
    },
    formatDateTime: function formatDateTime(dateStr) {
      if (!dateStr) return '';
      return dateStr;
    },
    getDefaultSearchForm: function getDefaultSearchForm() {
      return {
        orderDate: [],
        dispatchDate: [],
        deliveryDate: [],
        dealer: '',
        applyDate: [],
        sendDate: [],
        signDate: [],
        saleNo: '',
        customerName: '',
        customerPhone: '',
        customerAddress: '',
        contractNo: ''
      };
    },
    buildSearchParams: function buildSearchParams() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var includePagination = options.includePagination,
          includeStatus = options.includeStatus,
          dateFields = options.dateFields,
          textFields = options.textFields,
          page = options.page,
          size = options.size,
          textFieldAlias = options.textFieldAlias;
      var params = {};

      if (page !== undefined || includePagination !== false) {
        params.page = page !== undefined ? page : this.pagination.page - 1;
        params.size = size !== undefined ? size : this.pagination.pageSize;
      }

      if (includeStatus && this.activeStatus !== null) {
        params.status = this.activeStatus;
      }

      if (this.activeSendWay) {
        params.sendWay = this.activeSendWay;
      }

      var dateF = dateFields || ['orderDate', 'dispatchDate', 'deliveryDate', 'applyDate', 'sendDate', 'signDate'];
      dateF.forEach(function (field) {
        if (_this3.searchForm[field] && _this3.searchForm[field].length === 2) {
          var prefix = field.replace('Date', '');
          params["".concat(prefix, "DateStart")] = _this3.searchForm[field][0];
          params["".concat(prefix, "DateEnd")] = _this3.searchForm[field][1];
        }
      });
      var textF = textFields || ['dealer', 'saleNo', 'customerName', 'customerPhone', 'customerAddress', 'contractNo'];
      textF.forEach(function (field) {
        if (_this3.searchForm[field]) {
          params[textFieldAlias && textFieldAlias[field] || field] = _this3.searchForm[field];
        }
      });
      return params;
    },
    loadData: function loadData() {
      var _this4 = this;

      // 待发起使用独立接口，以 t_order_solution 为主表
      if (this.activeStatus === 0) {
        this.loadPendingSubmit();
        return;
      }

      var params = this.buildSearchParams({
        includeStatus: true
      });
      (0, _send.getSendList)(params).then(function (response) {
        if (response.code === 200) {
          var rawList = response.data.content || [];
          _this4.tableData = rawList.map(function (delivery, di) {
            return _objectSpread(_objectSpread({}, delivery), {}, {
              _rowKey: "d_".concat(di),
              salesman: delivery.contractGuideNickName,
              designer: delivery.contractDesignerNickName,
              signDate: delivery.contractSignatureDate,
              contractAgreedDays: delivery.agreedConstructionPeriod,
              contractAgreedPeriod: delivery.scheduledDeliveryDate,
              contractList: (delivery.contractList || []).map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  _deliveryId: delivery.id,
                  _rowKey: "".concat(delivery.id, "_").concat(item.contractId, "_").concat(item.designSchemeId, "_").concat(item.id),
                  phone: item.contactNumber,
                  salesman: item.guideNickName,
                  designer: item.designerNickName
                });
              })
            });
          });
          _this4.pagination.total = response.data.totalElements;
        }
      }).finally(function () {
        _this4.searchLoading = false;
      });
    },
    loadPendingSubmit: function loadPendingSubmit() {
      var _this5 = this;

      var params = this.buildSearchParams({
        dateFields: ['orderDate'],
        textFields: ['contractNo', 'customerName', 'customerPhone', 'customerAddress', 'dealer', 'saleNo'],
        textFieldAlias: {
          saleNo: 'orderNo'
        }
      });
      (0, _send.getPendingSubmit)(params).then(function (response) {
        if (response.code === 200) {
          var content = response.data.content || [];
          _this5.tableData = content.map(function (vo, ci) {
            var items = (vo.items || []).map(function (item, ii) {
              return _objectSpread(_objectSpread({}, item), {}, {
                contractId: vo.contractId,
                contractNo: vo.contractNo,
                contactPerson: vo.contactPerson,
                contactNumber: vo.contactNumber,
                contactAddress: vo.contactAddress,
                custName: vo.contactPerson,
                custMobile: vo.contactNumber,
                custAddress: vo.contactAddress,
                phone: vo.contactNumber,
                dealerShopName: vo.dealerShopName,
                scheduledDeliveryDate: vo.scheduledDeliveryDate,
                confirmPlanTime: vo.confirmPlanTime,
                agreedConstructionPeriod: vo.agreedConstructionPeriod,
                contractAgreedDays: vo.agreedConstructionPeriod,
                contractAgreedPeriod: vo.scheduledDeliveryDate,
                contractAmount: vo.amount,
                guideNickName: vo.guideNickName,
                designerNickName: vo.designerNickName,
                salesman: vo.guideNickName,
                designer: vo.designerNickName,
                orderNo: vo.orderNo,
                _rowKey: "ps_".concat(ci, "_").concat(ii)
              });
            });
            var hasSave = items.some(function (it) {
              return it.save && it.save.trim() !== '';
            });
            return {
              id: "".concat(vo.contractId, "_").concat(vo.orderNo),
              _rowKey: "ps_".concat(ci),
              status: hasSave ? -2 : 0,
              sendNumber: null,
              orderClerkTime: vo.auditCreateTime,
              contractNo: vo.contractNo,
              orderNo: vo.orderNo,
              custName: vo.contactPerson,
              custMobile: vo.contactNumber,
              custAddress: vo.contactAddress,
              dealerShopName: vo.dealerShopName,
              scheduledDeliveryDate: vo.scheduledDeliveryDate,
              confirmPlanTime: vo.confirmPlanTime,
              agreedConstructionPeriod: vo.agreedConstructionPeriod,
              guideNickName: vo.guideNickName,
              designerNickName: vo.designerNickName,
              salesOrderNo: vo.orderNo,
              orderData: vo.orderData,
              contractList: items,
              _rawItems: vo.items || []
            };
          });
          _this5.pagination.total = response.data.totalElements;
          _this5.statistics.pendingSubmit = response.data.totalElements;

          _this5._computeTotal();
        }
      }).finally(function () {
        _this5.searchLoading = false;
      });
    },
    loadStatistics: function loadStatistics() {
      var _this6 = this;

      var params = {};

      if (this.activeSendWay) {
        params.sendWay = this.activeSendWay;
      }

      params.statType = 'status';
      (0, _send.getSendStatisticsV2)(params).then(function (response) {
        if (response.code === 200) {
          var s = response.data;
          _this6.statistics.pendingCommit = s.pendingCommit || 0;
          _this6.statistics.pendingAppointment = s.pendingAppointment || 0;
          _this6.statistics.pendingDelivery = s.pendingDelivery || 0;
          _this6.statistics.pendingArrival = s.pendingArrival || 0;
          _this6.statistics.pendingReceipt = s.pendingReceipt || 0;
          _this6.statistics.delivered = s.delivered || 0;
          _this6.statistics.completed = s.completed || 0;
          _this6.statistics.pendingAudit = s.pendingAudit || 0;
          _this6.statistics.pendingPrint = s.pendingPrint || 0;
          _this6.statistics.pendingStock = s.pendingStock || 0;
          _this6.statistics.pendingSend = s.pendingSend || 0;
          _this6.statistics.shipped = s.shipped || 0;
          _this6._sendStatistics = s;

          _this6._computeTotal();
        }
      }); // 待发起数量与当前搜索条件一致

      this._loadPendingSubmitCount();
    },
    _loadPendingSubmitCount: function _loadPendingSubmitCount() {
      var _this7 = this;

      var params = this.buildSearchParams({
        page: 0,
        size: 1,
        dateFields: ['orderDate'],
        textFields: ['contractNo', 'customerName', 'customerPhone', 'customerAddress', 'dealer', 'saleNo'],
        textFieldAlias: {
          saleNo: 'orderNo'
        }
      });
      (0, _send.getPendingSubmit)(params).then(function (response) {
        if (response.code === 200) {
          _this7.statistics.pendingSubmit = response.data.totalElements;

          _this7._computeTotal();
        }
      });
    },
    _computeTotal: function _computeTotal() {
      if (this._sendStatistics) {
        var s = this._sendStatistics;

        if (this.activeSendWay && this.activeSendWay !== '配送(到家)' && this.activeSendWay !== '配送(到物流点)') {
          this.statistics.total = this.statistics.pendingSubmit + (s.pendingAudit || 0) + (s.pendingPrint || 0) + (s.pendingStock || 0) + (s.pendingSend || 0) + (s.shipped || 0);
        } else {
          this.statistics.total = this.statistics.pendingSubmit + (s.pendingCommit || 0) + s.pendingAppointment + s.pendingDelivery + s.pendingArrival + s.pendingReceipt + s.delivered + s.completed;
        }
      }
    },
    handleSearch: function handleSearch() {
      this.searchLoading = true;
      this.pagination.page = 1;
      this.loadData();

      if (this.activeStatus !== 0) {
        this.loadStatistics();
      }
    },
    handleExportList: function handleExportList() {
      var _this8 = this;

      // 待发起暂不支持导出（数据结构不同）
      if (this.activeStatus === 0) {
        this.$message.info('待发起列表暂不支持导出');
        return;
      }

      var params = this.buildSearchParams({
        includePagination: false,
        includeStatus: true
      });
      this.exportLoading = true;
      (0, _send.exportSendList)(params).then(function (res) {
        (0, _index.downloadFile)(res, '发货列表', 'xlsx');

        _this8.$message.success('导出成功');
      }).catch(function () {
        _this8.$message.error('导出失败');
      }).finally(function () {
        _this8.exportLoading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.searchForm = this.getDefaultSearchForm();
      this.activeStatus = 0;
      this.activeOtherStatus = 0;
      this.activeSendWay = '';
      this.handleSearch();
    },
    handleStatusTabClick: function handleStatusTabClick(status) {
      this.activeStatus = status;
      this.activeOtherStatus = status;
      this.handleSearch();
    },
    handleOtherStatusTabClick: function handleOtherStatusTabClick(status) {
      this.activeStatus = status;
      this.activeOtherStatus = status; // 非配送状态点击时，清空发货方式筛选以显示所有匹配记录

      if (status !== 0) {
        this.activeSendWay = '';
      }

      this.handleSearch();
    },
    handleSendWayTabClick: function handleSendWayTabClick(sendWay) {
      this.activeSendWay = sendWay;
      this.activeStatus = null;
      this.activeOtherStatus = null;
      this.handleSearch();
    },
    getStatusInfo: function getStatusInfo(status) {
      var map = {
        '-2': {
          label: '暂存',
          type: 'info'
        },
        '-1': {
          label: '预约异常',
          type: 'info'
        },
        0: {
          label: '待发起',
          type: 'warning'
        },
        1: {
          label: '待提交',
          type: 'success'
        },
        10: {
          label: '待预约',
          type: ''
        },
        20: {
          label: '待出发',
          type: 'primary'
        },
        30: {
          label: '待到达',
          type: 'cyan'
        },
        40: {
          label: '待送达',
          type: ''
        },
        50: {
          label: '待核算',
          type: 'success'
        },
        60: {
          label: '已核算',
          type: 'success'
        },
        1010: {
          label: '待审核',
          type: 'warning'
        },
        1020: {
          label: '待打单',
          type: ''
        },
        1030: {
          label: '待备货',
          type: 'primary'
        },
        1040: {
          label: '待发货',
          type: ''
        },
        1050: {
          label: '已发货',
          type: 'success'
        },
        1011: {
          label: '审核驳回',
          type: 'danger'
        }
      };
      return map[status] || {
        label: '未知',
        type: 'info'
      };
    },
    initTableHeader: function initTableHeader() {
      // 待发起表头：固定从配置文件读取
      this.pendingSubmitHeader = _deliveryColumns.default.map(function (col) {
        return _objectSpread({}, col);
      });
      var origDefault = [{
        key: 'sendNumber',
        label: '发货单号'
      }, {
        key: 'status',
        label: '发货单状态'
      }, {
        key: 'dealerShopName',
        label: '经销商'
      }, {
        key: 'orderClerkTime',
        label: '下单日期'
      }, {
        key: 'confirmPlanTime',
        label: '方案确认日期'
      }, {
        key: 'agreedConstructionPeriod',
        label: '工期天数'
      }, {
        key: 'scheduledDeliveryDate',
        label: '合同工期'
      }, {
        key: 'guideNickName',
        label: '销售'
      }, {
        key: 'designerNickName',
        label: '设计师'
      }, {
        key: 'custName',
        label: '客户姓名'
      }, {
        key: 'custMobile',
        label: '客户电话'
      }, {
        key: 'custAddress',
        label: '客户地址'
      }, {
        key: 'dispatchTime',
        label: '派单时间'
      }, {
        key: 'dispatchPerson',
        label: '派单人'
      }, {
        key: 'dispatchQuantity',
        label: '派单件数'
      }, {
        key: 'sendWay',
        label: '发货方式'
      }, {
        key: 'hasProduct',
        label: '大家居'
      }, {
        key: 'sendDate',
        label: '上门日期'
      }, {
        key: 'sendTime',
        label: '上门时间'
      }, {
        key: 'receivePerson',
        label: '收货人'
      }, {
        key: 'receivePhone',
        label: '收货电话'
      }, {
        key: 'sendPerson',
        label: '送货司机'
      }, {
        key: 'driverPhone',
        label: '司机电话'
      }, {
        key: 'carNumber',
        label: '送货车辆'
      }, {
        key: 'enterType',
        label: '进门方式'
      }, {
        key: 'enterRemark',
        label: '进门备注'
      }, {
        key: 'remark',
        label: '派单备注'
      }, {
        key: 'reserveTime',
        label: '预约时间'
      }, {
        key: 'reserveTimeliness',
        label: '预约及时性'
      }, {
        key: 'departureTime',
        label: '出发时间'
      }, {
        key: 'signTime',
        label: '签到时间'
      }, {
        key: 'arrivalTimeliness',
        label: '到达及时性'
      }, {
        key: 'deliveryTime',
        label: '送达时间'
      }]; // this.otherHeader = origDefault.map((col, index) => ({
      //   key: col.key,
      //   label: col.label,
      //   visible: true,
      //   sort: index
      // }))

      this.otherHeader = _deliveryColumns.default.map(function (col) {
        return _objectSpread({}, col);
      });
      this.loadHeaderConfig();
      this.syncTableHeader();
    },
    loadHeaderConfig: function loadHeaderConfig() {
      var _this9 = this;

      if (!this.otherHeader || this.otherHeader.length === 0) return;
      var savedConfig = localStorage.getItem('deliveryHeaderConfig');

      if (savedConfig) {
        try {
          var config = JSON.parse(savedConfig);
          config.forEach(function (item) {
            var col = _this9.otherHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
              col.sort = item.sort !== undefined ? item.sort : col.sort;
            }

            col = _this9.pendingSubmitHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
              col.sort = item.sort !== undefined ? item.sort : col.sort;
            }
          });
          this.otherHeader.sort(function (a, b) {
            return a.sort - b.sort;
          });
          this.pendingSubmitHeader.sort(function (a, b) {
            return a.sort - b.sort;
          });
        } catch (e) {
          console.error('加载表头配置失败:', e);
        }
      }
    },
    syncTableHeader: function syncTableHeader() {
      this.tableHeader = this.activeStatus === 0 ? this.pendingSubmitHeader : this.otherHeader;
    },
    isColumnVisible: function isColumnVisible(key) {
      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      return col ? col.visible : true;
    },
    toggleColumnVisible: function toggleColumnVisible(key) {
      var idx = this.tableHeader.findIndex(function (c) {
        return c.key === key;
      });

      if (idx !== -1) {
        this.$set(this.tableHeader[idx], 'visible', !this.tableHeader[idx].visible);
        this.tableRenderKey++;
      }
    },
    getColumnValue: function getColumnValue(key, row) {
      if (!row) return '-';

      if (key === 'status') {
        return this.getStatusInfo(row.status).label;
      }

      if (key === 'sendDate') {
        return this.formatDate(row.sendDate);
      }

      if (key === 'sendPerson') {
        return this.parseSendPerson(row.sendPerson) || '-';
      } // 预约倒计时：通过 t_send_task_log step=10(预约日志) 判断是否已预约


      if (key === 'reserveCountdown') {
        if (row.reserveTime) {
          return '-';
        }

        return this.computeCountdown(row, 10);
      } // 上门倒计时：待出发/待到达/待送达状态下，基于上门日期计算


      if (key === 'visitCountdown') {
        if (row.deliveryTime) {
          return '-';
        }

        return this.computeCountdown(row, [20, 30, 40]);
      } // 已等待时长：从派单时间到现在的时长


      if (key === 'waitDuration') {
        return this.computeWaitDuration(row);
      } // 包数统计：从 contractList 子项聚合计算


      if (key === 'initiatedPackages' || key === 'uninitiatedPackages' || key === 'shippedPackages' || key === 'unshippedPackages') {
        return this.computePackageStats(key, row);
      } // 未收金额：合同金额 - 已收金额（先取合同列表，无则取主行）


      if (key === 'unreceivedAmount') {
        var contract = row.contractList && row.contractList[0];
        var amount = contract && contract.contractAmount != null ? contract.contractAmount : row.contractAmount;
        var received = contract && contract.receivedAmount != null ? contract.receivedAmount : row.receivedAmount;
        if (amount != null) return ((amount || 0) - (received || 0)).toFixed(2);
        return '-';
      } // 收款比例 = 已收金额 / 合同金额


      if (key === 'paymentRatio') {
        var _contract = row.contractList && row.contractList[0];

        var _amount = _contract && _contract.contractAmount != null ? _contract.contractAmount : row.contractAmount;

        var _received = _contract && _contract.receivedAmount != null ? _contract.receivedAmount : row.receivedAmount;

        if (_amount != null && _amount > 0) return ((_received || 0) / _amount * 100).toFixed(0) + '%';
        return '-';
      } // 从 orderData JSON 中获取订单相关字段


      var orderDataKeys = ['productName', 'color', 'stone', 'stoneColor', 'orderType', 'basinSource', 'basinQuantity', 'basinModel', 'faucetSource', 'faucetQuantity', 'faucetModel', 'orderTime', 'approveOrderTime', 'dismantleTime', 'approveQuoteTime', 'approveFinanceTime', 'receiveTime', 'palnProductionTime', 'shipmentDatePromise', 'productionStartDateTime', 'completeSetDate', 'productionStatus', 'actualOutTime', 'totalArea', 'expandArea', 'stoneLeng', 'totalPack', 'inPack', 'warehouse', 'storage'];

      if (orderDataKeys.includes(key) && row.orderData) {
        try {
          var od = typeof row.orderData === 'string' ? JSON.parse(row.orderData) : row.orderData;
          var val = od[key];

          if (val != null && val !== '') {
            if (key === 'productionStatus') {
              return this.productionStatusMap[Number(val)] || val;
            }

            return key === 'color' || key === 'colorDesc' ? this._formatColor(val) : val;
          }
        } catch (e) {}
      } // 从合同列表中取第一条合同的相关字段


      var contractKeys = ['dealerShopName', 'contractNo', 'custName', 'custMobile', 'custAddress', 'phone', 'salesman', 'designer', 'confirmPlanTime', 'agreedConstructionPeriod', 'scheduledDeliveryDate', 'contractAgreedDays', 'contractAgreedPeriod', 'contractAmount', 'receivedAmount', 'guideNickName', 'designerNickName', 'signDate', 'volume', 'colorDesc', 'approveDealerTime', 'scheduleTime', 'promiseShipmentTime', 'startProductionTime', 'planInTime', 'actualInTime', 'inStatus', 'acutalOutTime', 'fangMenArea', 'packPlateQuantity', 'unPackPlateQuantity'];

      if (contractKeys.includes(key)) {
        var _contract2 = row.contractList && row.contractList[0];

        if (_contract2) {
          // storage 在子项中字段名为 location
          var contractField = key === 'storage' ? 'location' : key;
          var _val = _contract2[contractField];

          if (_val != null && _val !== '') {
            if (['confirmPlanTime', 'scheduledDeliveryDate', 'signDate', 'approveDealerTime', 'promiseShipmentTime', 'startProductionTime', 'planInTime', 'actualInTime', 'acutalOutTime', 'contractAgreedPeriod'].includes(key)) {
              return this.formatDate(_val);
            }

            if (key === 'guideNickName' || key === 'designerNickName' || key === 'salesman' || key === 'designer') {
              try {
                var arr = JSON.parse(_val);

                if (Array.isArray(arr)) {
                  return arr.map(function (p) {
                    if (typeof p === 'string') return p;
                    return p.userName || p.realName || p.name || '';
                  }).filter(Boolean).join(', ') || '-';
                }
              } catch (e) {}
            }

            return key === 'color' || key === 'colorDesc' ? this._formatColor(_val) : _val;
          } // 尝试从 materialData JSON 中解析


          if (_contract2.materialData) {
            try {
              var md = typeof _contract2.materialData === 'string' ? JSON.parse(_contract2.materialData) : _contract2.materialData;
              var pv = md[key];

              if (pv != null && pv !== '') {
                if (['approveDealerTime', 'scheduleTime', 'promiseShipmentTime', 'startProductionTime', 'planInTime', 'actualInTime', 'acutalOutTime'].includes(key)) {
                  return this.formatDate(pv);
                }

                return key === 'color' || key === 'colorDesc' ? this._formatColor(pv) : pv;
              }
            } catch (_unused) {}
          }
        } // fallback: 取主行上的字段值


        var dateKeys = ['confirmPlanTime', 'scheduledDeliveryDate', 'signDate', 'approveDealerTime', 'promiseShipmentTime', 'startProductionTime', 'planInTime', 'actualInTime', 'acutalOutTime', 'contractAgreedPeriod'];
        var rowVal = row[key];

        if (rowVal != null && rowVal !== '') {
          return dateKeys.includes(key) ? this.formatDate(rowVal) : rowVal;
        }

        return '-';
      } // 特殊日期字段


      if (key === 'orderClerkTime') {
        return row.orderClerkTime ? this.formatDate(row.orderClerkTime) : '-';
      }

      if (key === 'dispatchTime' || key === 'signTime' || key === 'deliveryTime' || key === 'accountingTime' || key === 'auditTime' || key === 'shipTime') {
        return row[key] ? this.formatDateTime(row[key]) : '-';
      }

      if (key === 'reserveTime' || key === 'departureTime' || key === 'pickupTime') {
        return row[key] ? this.formatDateTime(row[key]) : '-';
      }

      if (key === 'reserveTimeliness' || key === 'arrivalTimeliness') {
        return row[key] || '-';
      }

      if (key === 'attachment') {
        var _val2 = row[key];

        if (Array.isArray(_val2)) {
          return _val2.length || '0';
        }

        if (typeof _val2 === 'string' && _val2) {
          try {
            var parsed = JSON.parse(_val2);
            if (Array.isArray(parsed)) return parsed.length || '0';
          } catch (_unused2) {}
        }

        return '0';
      }

      if (key === 'logisticsNo') {
        var _val3 = row[key];

        if (Array.isArray(_val3)) {
          return _val3.length || '0';
        }

        if (typeof _val3 === 'string' && _val3) {
          try {
            var _parsed = JSON.parse(_val3);

            if (Array.isArray(_parsed)) return _parsed.length || '0';
          } catch (_unused3) {}
        }

        return '0';
      }

      if (key === 'loadingCompleteImg' || key === 'shipList' || key === 'siteCheckImg' || key === 'deliveryCompleteImg' || key === 'deliveryReceipt' || key === 'siteCheckVideo') {
        var _val4 = row[key];

        if (typeof _val4 === 'string' && _val4) {
          // 尝试解析 JSON 数组（如 ["url1","url2"]）
          try {
            var _parsed2 = JSON.parse(_val4);

            if (Array.isArray(_parsed2)) return _parsed2.length || '0';
          } catch (_unused4) {}

          return _val4.split(',').filter(function (u) {
            return u.trim();
          }).length || '0';
        }

        return '0';
      } // 字段别名映射: deliveryColumns key -> 后端 SendVo 实际字段名


      var fieldAliasMap = {
        bigHome: 'hasProduct',
        visitDate: 'sendDate',
        visitTime: 'sendTime',
        consignee: 'receivePerson',
        consigneePhone: 'receivePhone',
        consigneeAddress: 'receiveAddress',
        vehicle: 'carNumber',
        driverName: 'sendPerson',
        entryMethod: 'enterType',
        remark1: 'enterRemark',
        remark2: 'remark',
        reservationPerson: 'reservePerson',
        reservationTime: 'reserveTime',
        reservationTimeliness: 'reserveTimeliness',
        courierCompany: 'sendCompany',
        trackingNo: 'expressNumber',
        expectedPickupDate: 'sendDate',
        expectedPickupTime: 'sendTime',
        collectionTime: 'exeressReciveTime',
        collectionImg: 'expressPhoto',
        shipper: 'sender',
        checkInPerson: 'signPerson',
        checkInTime: 'signTime',
        deliveryNo: 'sendNumber',
        initiator: 'dispatchPerson',
        initiateTime: 'dispatchTime'
      };

      if (fieldAliasMap[key]) {
        var actualKey = fieldAliasMap[key];
        var _val5 = row[actualKey];

        if (_val5 != null && _val5 !== '') {
          if (key === 'visitDate' || key === 'expectedDeliveryDate' || key === 'expectedPickupDate') {
            return this.formatDate(_val5);
          }

          if (key === 'reservationTime' || key === 'collectionTime' || key === 'checkInTime' || key === 'initiateTime') {
            return this.formatDateTime(_val5);
          }

          if (key === 'driverName') {
            return this.parseSendPerson(_val5) || '-';
          }

          if (key === 'collectionImg') {
            if (Array.isArray(_val5)) return _val5.length || '0';

            if (typeof _val5 === 'string') {
              try {
                var p = JSON.parse(_val5);
                if (Array.isArray(p)) return p.length || '0';
              } catch (_unused5) {}
            }

            return '0';
          }

          return _val5;
        }

        return '-';
      }

      return row[key] || '-';
    },
    computeCountdown: function computeCountdown(row, targetStatus) {
      var statuses = Array.isArray(targetStatus) ? targetStatus : [targetStatus];
      if (!statuses.includes(row.status)) return '-';
      if (!row.sendDate) return '-';

      try {
        // 从 sendTime 中提取第一个时间（如 "08:00 ~ 10:00" -> "08:00:00"）
        var timePart = '00:00:00';
        var sendTime = row.sendTime;

        if (sendTime) {
          var times = String(sendTime).split(/[~\s-]+/);

          if (times[0]) {
            timePart = times[0].trim();
            if (timePart.split(':').length === 2) timePart += ':00';
          }
        } // 拼接完整目标时间


        var dateStr = typeof row.sendDate === 'string' ? row.sendDate.split(' ')[0] : row.sendDate;
        var targetTime = new Date(dateStr + ' ' + timePart).getTime();
        var diffSeconds = Math.floor((targetTime - Date.now()) / 1000);
        if (diffSeconds < 0) return '-';
        var days = Math.floor(diffSeconds / 86400);
        var hours = Math.floor(diffSeconds % 86400 / 3600);
        var minutes = Math.floor(diffSeconds % 3600 / 60);
        var seconds = diffSeconds % 60;
        var dayStr = days > 0 ? days + '天 ' : '';
        return dayStr + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      } catch (e) {
        return '-';
      }
    },
    computeWaitDuration: function computeWaitDuration(row) {
      if (row.status === 60) return '-';
      if (!row.dispatchTime && !row.createTime) return '-';

      try {
        var startTime = new Date(row.dispatchTime || row.createTime).getTime();
        var diffSeconds = Math.floor((Date.now() - startTime) / 1000);
        if (diffSeconds < 0) return '-';
        var days = Math.floor(diffSeconds / 86400);
        var hours = Math.floor(diffSeconds % 86400 / 3600);
        var minutes = Math.floor(diffSeconds % 3600 / 60);
        if (days > 0) return days + '天' + hours + '小时';
        if (hours > 0) return hours + '小时' + minutes + '分钟';
        return minutes + '分钟';
      } catch (e) {
        return '-';
      }
    },
    computePackageStats: function computePackageStats(key, row) {
      var items = row.contractList || [];
      if (items.length === 0) return 0;
      var totalPkgs = items.reduce(function (sum, item) {
        return sum + (item.packages || 0);
      }, 0); // 待发起(status=0)或暂存(status=-2)均视为未发起

      var isPending = row.status === 0 || row.status === -2;

      if (key === 'initiatedPackages') {
        return isPending ? 0 : totalPkgs;
      }

      if (key === 'uninitiatedPackages') {
        return isPending ? totalPkgs : 0;
      } // 已出库：待发起/暂存=0，其他=派单件数


      var shipped = isPending ? 0 : row.dispatchQuantity != null ? row.dispatchQuantity : 0;

      if (key === 'shippedPackages') {
        return shipped;
      }

      if (key === 'unshippedPackages') {
        return Math.max(0, totalPkgs - shipped);
      }

      return 0;
    },
    handleAttachmentClick: function handleAttachmentClick(row, key) {
      var _this10 = this;

      var fieldKey = key || 'attachment';
      var attachAlias = {
        collectionImg: 'expressPhoto',
        shipList: 'shipList'
      };
      var actualKey = attachAlias[fieldKey] || fieldKey;
      var val = row[actualKey];
      var rawList = [];

      if (Array.isArray(val)) {
        rawList = val;
      } else if (typeof val === 'string' && val) {
        try {
          var parsed = JSON.parse(val);
          rawList = Array.isArray(parsed) ? parsed : [parsed];
        } catch (_unused6) {
          rawList = [];
        }
      }

      if (rawList.length === 0) {
        this.$message.info('暂无附件');
        return;
      } // 构建预览列表：解析内层 JSON、拼接 OSS 前缀


      var imgPrefix = this.$store.getters.imgPreviewPrefix || '';
      var filePrefix = this.$store.getters.filePreviewPrefix || '';
      this.attachmentPreviewList = rawList.map(function (item) {
        var parsed = typeof item === 'string' ? _this10.tryParseJson(item) : item;
        var name = parsed && (parsed.localName || parsed.alias || parsed.realName) || (typeof item === 'string' ? item : '未知文件');

        var isImage = _this10.isImageFile(name);

        var prefix = isImage ? imgPrefix : filePrefix;
        var rawUrl = parsed && parsed.url || (parsed ? parsed.realName : '') || (typeof item === 'string' ? item : '');
        var url = rawUrl.startsWith('http') ? rawUrl : prefix + rawUrl;
        return {
          url: url,
          name: name,
          isImage: isImage
        };
      });
      this.attachmentDialogVisible = true;
    },
    handleImageClick: function handleImageClick(row, key) {
      var _this11 = this;

      if (key === 'attachment' || key === 'collectionImg' || key === 'logisticsNo') {
        this.handleAttachmentClick(row, key);
        return;
      } // 图片/视频字段：拼接 OSS 前缀预览


      var imgLabels = {
        loadingCompleteImg: '装车完成图',
        shipList: '发货清单',
        siteCheckImg: '现场检查图',
        deliveryCompleteImg: '送货完成图',
        deliveryReceipt: '送货单'
      };
      var isVideoField = key === 'siteCheckVideo';

      if (imgLabels[key] || isVideoField) {
        var val = row[key];

        if (!val || typeof val !== 'string') {
          this.$message.info(isVideoField ? '暂无视频' : '暂无图片');
          return;
        }

        var imgPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePrefix = this.$store.getters.filePreviewPrefix || '';
        var rawList = this.parseMediaArray(val);
        var urls = rawList.map(function (item) {
          var parsed = typeof item === 'string' ? _this11.tryParseJson(item) : item; // 当 item 是纯 URL 字符串时，parsed 仍是字符串；否则 parsed 是对象

          if (typeof parsed === 'string') {
            var urlStr = parsed;
            var fileName = urlStr.split('/').pop() || '';

            var _name = fileName || imgLabels[key] || '未知文件';

            var _isImage = isVideoField ? false : _this11.isImageFile(fileName) || _this11.isImageFile(urlStr);

            var _prefix = _isImage ? imgPrefix : filePrefix;

            var _url = urlStr.startsWith('http') ? urlStr : _prefix + urlStr;

            return {
              url: _url,
              name: _name,
              isImage: _isImage,
              isVideo: isVideoField
            };
          }

          var realName = parsed.realName || '';
          var localName = parsed.localName || parsed.alias || '';
          var name = localName || realName || imgLabels[key] || '未知文件';
          var isImage = isVideoField ? false : _this11.isImageFile(name);
          var prefix = isImage ? imgPrefix : filePrefix;
          var rawUrl = parsed.url || realName || name;
          var url = rawUrl.startsWith('http') ? rawUrl : prefix + rawUrl;
          return {
            url: url,
            name: name,
            isImage: isImage,
            isVideo: isVideoField
          };
        });

        if (urls.length === 0) {
          this.$message.info(isVideoField ? '暂无视频' : '暂无图片');
          return;
        }

        this.attachmentPreviewList = urls;
        this.attachmentDialogVisible = true;
      }
    },
    parseMediaArray: function parseMediaArray(val) {
      if (!val || typeof val !== 'string') return [];

      try {
        var parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return parsed; // JSON 解析成功但不是数组（如单个对象），包装为数组

        return [parsed];
      } catch (_unused7) {}

      return val.split(',').map(function (u) {
        return u.trim();
      }).filter(Boolean);
    },
    tryParseJson: function tryParseJson(val) {
      if (typeof val !== 'string') return val;

      try {
        return JSON.parse(val);
      } catch (_unused8) {
        return val;
      }
    },
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'];
      var ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return imgExtensions.includes(ext);
    },
    downloadAttachment: function downloadAttachment(item) {
      if (item.url) {
        fetch(item.url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          // 跨域时直接打开
          window.open(item.url, '_blank');
        });
      }
    },
    getStrWidth: function getStrWidth(str) {
      var width = 0;

      var _iterator = _createForOfIteratorHelper(String(str)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          if (/[\u4e00-\u9fa5]/.test(char)) {
            width += 24;
          } else if (/[0-9]/.test(char)) {
            width += 10;
          } else {
            width += 10;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return width;
    },
    getColumnWidth: function getColumnWidth(key) {
      var _this12 = this;

      if (!this.tableData || this.tableData.length === 0) {
        return 140;
      }

      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      var headerWidth = this.getStrWidth(col ? col.label : key);
      var values = this.tableData.map(function (row) {
        return _this12.getColumnValue(key, row) || '';
      });
      var dataWidth = Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (v) {
        return _this12.getStrWidth(v);
      })));
      var maxWidth = Math.max(headerWidth, dataWidth);
      var minWidth = 80;
      return Math.max(maxWidth + 20, minWidth);
    },
    moveAllToLeft: function moveAllToLeft() {
      this.tableHeader.forEach(function (col) {
        col.visible = false;
      });
      this.tableRenderKey++;
    },
    moveAllToRight: function moveAllToRight() {
      this.tableHeader.forEach(function (col) {
        col.visible = true;
      });
      this.tableRenderKey++;
    },
    openConfigDialog: function openConfigDialog() {
      this.originalHeaderConfig = this.tableHeader.map(function (col, index) {
        return {
          key: col.key,
          visible: col.visible,
          sort: index
        };
      });
      this.configDialogVisible = true;
    },
    saveHeaderConfig: function () {
      var _saveHeaderConfig = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this13 = this;

        var config, dictData, updatePromises;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = this.tableHeader.map(function (col, index) {
                  return {
                    key: col.key,
                    visible: col.visible,
                    sort: index
                  };
                });
                localStorage.setItem('deliveryHeaderConfig', JSON.stringify(config));
                dictData = this.dict.delivery_list_display_fieIds;
                updatePromises = [];
                config.forEach(function (item, index) {
                  var originalItem = _this13.originalHeaderConfig.find(function (o) {
                    return o.key === item.key;
                  });

                  if (originalItem && (originalItem.visible !== item.visible || originalItem.sort !== index)) {
                    var dictItem = dictData.find(function (d) {
                      return d.value === item.key;
                    });

                    if (dictItem && dictItem.id) {
                      updatePromises.push((0, _dictDetail.edit)({
                        id: dictItem.id,
                        dict: {
                          id: dictItem.dict.id
                        },
                        value: dictItem.value,
                        label: dictItem.label,
                        unit: item.visible,
                        dictSort: index
                      }));
                    }
                  }
                });

                if (!(updatePromises.length > 0)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return Promise.all(updatePromises);

              case 9:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this13.handleSearch();
                });
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.error('保存字典配置失败:', _context.t0);
                this.$message.warning('本地保存成功，但服务器保存失败');
                this.$nextTick(function () {
                  _this13.handleSearch();
                });

              case 18:
                _context.next = 22;
                break;

              case 20:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this13.handleSearch();
                });

              case 22:
                this.configDialogVisible = false;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13]]);
      }));

      function saveHeaderConfig() {
        return _saveHeaderConfig.apply(this, arguments);
      }

      return saveHeaderConfig;
    }(),
    resetHeaderConfig: function resetHeaderConfig() {
      var fields = this.dict.delivery_list_display_fieIds.filter(function (item) {
        return item.value && item.label;
      });
      var newTableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      newTableHeader.sort(function (a, b) {
        return a.sort - b.sort;
      });
      this.tableHeader = newTableHeader;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleNestedSelectionChange: function handleNestedSelectionChange(rowId, val) {
      this.$set(this.nestedSelectedRowIds, rowId, val.length > 0); // 子表选择变化时，同步父行勾选状态（双向联动）

      if (this._syncChildLock) return;
      var parentRow = this.tableData.find(function (r) {
        return r._rowKey === rowId;
      });

      if (parentRow) {
        var childCount = (parentRow.contractList || []).length;

        if (childCount > 0) {
          this._syncChildLock = true;

          try {
            if (val.length === childCount) {
              this.$refs.mainTable.toggleRowSelection(parentRow, true);
            } else if (val.length === 0) {
              this.$refs.mainTable.toggleRowSelection(parentRow, false);
            }
          } finally {
            this._syncChildLock = false;
          }
        }
      }
    },
    handleMainSelect: function handleMainSelect() {// 仅做选择，不联动展开
    },
    handleMainSelectAll: function handleMainSelectAll() {// 仅做选择，不联动展开
    },
    handleRowClick: function handleRowClick(row) {
      this.$refs.mainTable.toggleRowExpansion(row);
    },
    handleDeliveryInstruction: function handleDeliveryInstruction() {
      var _this14 = this;

      // 收集所有有选择的行：主表selectedRows + 二级表格勾选的行
      var selectedRowIds = new Set(this.selectedRows.map(function (r) {
        return r._rowKey;
      }));
      Object.entries(this.nestedSelectedRowIds).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            rowKey = _ref2[0],
            hasSel = _ref2[1];

        if (hasSel) selectedRowIds.add(rowKey);
      });
      var allSelectedRows = this.tableData.filter(function (r) {
        return selectedRowIds.has(r._rowKey);
      });

      if (allSelectedRows.length === 0) {
        this.$message.warning('请先选择要发起发货指令的数据');
        return;
      } // 收集选中的主表行数据及其嵌套选择


      var instructionData = allSelectedRows.map(function (row) {
        var contracts = [];

        if (_this14.activeStatus === 0) {
          // 待发起：直接使用contractList映射_rawItems，无需展开嵌套表格
          var rawItems = row._rawItems || [];
          var contractList = row.contractList || [];

          if (rawItems.length > 0) {
            var rawMap = new Map(rawItems.map(function (item) {
              return [item.id, item];
            }));
            contracts = contractList.map(function (c) {
              var raw = rawMap.get(c.id);
              return raw ? _objectSpread(_objectSpread({}, raw), c) : c;
            });
          } else {
            contracts = contractList;
          }
        } else {
          // 非待发起：从已展开的嵌套表格中读取勾选的行
          var selectedContracts = [];

          try {
            var nestedTable = _this14.$refs['contractTable_' + row._rowKey];

            if (nestedTable) {
              var table = Array.isArray(nestedTable) ? nestedTable[0] : nestedTable;
              selectedContracts = table.store ? table.store.states.selection : [];
            }
          } catch (e) {
            selectedContracts = [];
          }

          var _rawItems = row._rawItems || [];

          if (_rawItems.length > 0) {
            var _rawMap = new Map(_rawItems.map(function (item) {
              return [item.id, item];
            }));

            contracts = selectedContracts.map(function (c) {
              var raw = _rawMap.get(c.id);

              return raw ? _objectSpread(_objectSpread({}, raw), c) : c;
            });
          } else {
            contracts = selectedContracts;
          }
        }

        return {
          deliveryId: row._rowKey,
          sendNumber: row.sendNumber,
          dealerShopName: row.dealerShopName,
          status: row.status,
          contracts: contracts
        };
      }); // 检查是否存在暂存(save)的方案

      var allContracts = instructionData.flatMap(function (d) {
        return d.contracts || [];
      });
      var draftContracts = allContracts.filter(function (c) {
        return c.save && c.save.trim() !== '';
      });

      if (draftContracts.length > 0) {
        // 按暂存信息去重，相同save只保留一条
        var seenSave = new Map();
        var uniqueDraftContracts = [];
        draftContracts.forEach(function (c) {
          if (!seenSave.has(c.save)) {
            seenSave.set(c.save, true);
            uniqueDraftContracts.push(c);
          }
        }); // 去重后只有一种暂存信息，无需选择，直接发起

        if (uniqueDraftContracts.length === 1) {
          this.doDeliveryInstruction(instructionData, uniqueDraftContracts[0].save);
          return;
        }

        this.draftSourceData = instructionData;
        this.draftItems = uniqueDraftContracts;
        this.draftSelectedId = uniqueDraftContracts[0].id;
        this.draftDialogVisible = true;
        return;
      }

      this.doDeliveryInstruction(instructionData);
    },
    handleDraftCurrentChange: function handleDraftCurrentChange(row) {
      if (row) {
        this.draftSelectedId = row.id;
      }
    },
    getParsedSave: function getParsedSave(item) {
      if (!item || !item.save) return null;

      try {
        return typeof item.save === 'string' ? JSON.parse(item.save) : item.save;
      } catch (e) {
        return null;
      }
    },
    confirmDraftSelection: function confirmDraftSelection() {
      var _this15 = this;

      if (!this.draftSelectedId) {
        this.$message.warning('请选择一个方案');
        return;
      } // 传递所有选中行数据，同时记录选中的暂存 ID 和数据


      var selectedItem = this.draftItems.find(function (it) {
        return it.id === _this15.draftSelectedId;
      });
      this.draftDialogVisible = false;
      this.doDeliveryInstruction(this.draftSourceData, selectedItem ? selectedItem.save : null);
    },
    clearDraftAndGo: function clearDraftAndGo() {
      this.draftDialogVisible = false;
      this.doDeliveryInstruction(this.draftSourceData, null);
    },
    _formatColor: function _formatColor(val) {
      if (val == null) return '-';
      return String(val).replace(/^,+/g, '').replace(/,+$/g, '').replace(/,/g, '\n');
    },
    _getProductionOrder: function _getProductionOrder(c) {
      if (c.productionOrder) return c.productionOrder;

      if (c.materialData) {
        try {
          var m = typeof c.materialData === 'string' ? JSON.parse(c.materialData) : c.materialData;
          return m.productionOrder || '';
        } catch (_unused9) {
          /* ignore */
        }
      }

      return '';
    },
    doDeliveryInstruction: function doDeliveryInstruction(instructionData, selectedSaveData) {
      var _this16 = this;

      // 统一缓存：items 为扁平化的原始数据，saveData 为暂存信息，customer 为客户数据
      var items = instructionData.flatMap(function (d) {
        return (d.contracts || []).map(function (c) {
          return {
            id: c.id,
            productionOrder: _this16._getProductionOrder(c)
          };
        });
      });
      var firstInstruction = instructionData[0] || {};
      var firstRow = this.tableData.find(function (r) {
        return r._rowKey === firstInstruction.deliveryId;
      }) || {};
      var cache = {
        items: items,
        saveData: selectedSaveData || null,
        customer: {
          contactPerson: firstRow.custName || firstRow.contactPerson || '',
          contactNumber: firstRow.custMobile || firstRow.contactNumber || '',
          contactAddress: firstRow.custAddress || firstRow.contactAddress || '',
          coordinate: firstRow.positioning || firstRow.coordinate || ''
        }
      };
      sessionStorage.setItem('delivery_contractList', JSON.stringify(cache));
      this.$router.push({
        path: '/cms/delivery/create'
      });
    },
    handleDetail: function handleDetail(row) {
      var _this17 = this;

      // 将合同列表缓存传递到创建页面，确保详情查看时合同数据不丢失
      var items = (row.contractList || []).map(function (c) {
        return {
          id: c.id,
          productionOrder: _this17._getProductionOrder(c)
        };
      });
      var cache = {
        items: items,
        saveData: null,
        customer: {
          contactPerson: row.custName || row.receivePerson || row.contactPerson || '',
          contactNumber: row.custMobile || row.receivePhone || row.contactNumber || '',
          contactAddress: row.custAddress || row.receiveAddress || row.contactAddress || '',
          coordinate: row.positioning || row.coordinate || ''
        }
      };
      sessionStorage.setItem('delivery_contractList', JSON.stringify(cache));
      this.$router.push({
        path: '/cms/delivery/create',
        query: {
          editId: row.id
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.page = 1;
      this.pagination.pageSize = val;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.loadData();
    },
    parseSendPerson: function parseSendPerson(sendPerson) {
      if (!sendPerson) return '';

      try {
        var arr = JSON.parse(sendPerson);

        if (Array.isArray(arr)) {
          return arr.map(function (p) {
            var name = p.userName || p.realName || '';
            var phone = p.userPhone || '';
            return phone ? "".concat(name, " ").concat(phone) : name;
          }).filter(Boolean).join('、');
        }

        return sendPerson;
      } catch (_unused10) {
        return sendPerson;
      }
    }
  }
};
exports.default = _default;